import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Tab, Tabs } from '../../../../../components/tabs';
import CartaoLink from './cartao-link';
import Boleto from './boleto';

const formaPagamento = [
  {
    label: 'Boleto',
    value: 'BOLETO',
  },
  {
    label: 'Cartão',
    value: 'CARTAO',
  },
];

export const CartaoForm = ({
  handleDadosCadastrais,
  dadosCadastrais,
  pacienteId,
}) => {
  const [selectedTab, setSelectedTab] = useState('BOLETO');
  const [infoBoleto, setInfoBoleto] = useState({
    id: dadosCadastrais?.plano?.id,
    valorSubtotal: dadosCadastrais?.plano?.valorMensal,
    quantidadeParcelas: 1,
    emailPagador: dadosCadastrais.email,
  });

  const handlePagamento = (value, key) => {
    setInfoBoleto((infoBoleto) => ({ ...infoBoleto, [key]: value }));
  };

  return (
    <Grid
      container
      spacing={2}
      style={{
        padding: '0px',
        margin: '0px',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <div style={{ width: 'fit-content' }}>
          <Tabs
            onChange={(newValue) => setSelectedTab(newValue)}
            value={selectedTab}
          >
            {formaPagamento.map(({ value, label }) => (
              <Tab value={value}>{label}</Tab>
            ))}
          </Tabs>
        </div>
      </Grid>
      <Grid item xs={12} style={{ padding: '10px' }}>
        {selectedTab === 'CARTAO' && <CartaoLink pacienteId={pacienteId} />}
        {selectedTab === 'BOLETO' && (
          <Boleto
            dadosBoleto={infoBoleto}
            handleMeioPagamento={handlePagamento}
          />
        )}
      </Grid>
    </Grid>
  );
};

const Row = styled.div`
  display: flex;
  gap: 5px;
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;
const LabelField = styled.label`
  color: #868686;
  font-size: 12px;
  height: 16px;
`;

const ContentCartao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  width: 160px;
  height: 40px;
  background-color: #505050;
  border-radius: 100px;
  border: 2px solid rgba(220, 220, 220, 0.2);
  gap: 8px;
  justify-content: space-between;
  padding: 0 16px;
  color: #fff;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  ${(props) => props.disabled && 'opacity: 0.5'};
`;

const LabelButton = styled.label`
  font-weight: 600;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const MensagemLinkPagamento = styled.div`
  color: #505050;
  justify-content: center;
  font-size: 1rem;
`;

const LinkPagamento = styled.div`
  background-color: #f2f2f2;
  border-radius: 8px;
  border: 1px solid #dcdcdc33;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 4px;
  height: 32px;
  justify-content: space-between;
  width: 100%;
`;

const ButtonCopy = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

const ContentLink = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;
